const CUSTOMER_INFO_FIELD_ALIASES = {
  visitor_id: ["visitor_id", "visitorId"],
  roles: ["roles"],
  customer_type: ["customer_type", "customerType"],
  phone_number: ["phone_number", "phoneNumber", "phone"],
  email: ["email"],
  full_name: ["full_name", "fullName"],
  first_name: ["first_name", "firstName"],
  last_name: ["last_name", "lastName"],
  language: ["language", "lang", "locale", "appLocale", "app_locale"],
  company: ["company"],
  company_id: ["company_id", "companyId"],
  jobtitle: ["jobtitle", "jobTitle"],
  status: ["status"],
  source: ["source", "context"],
  extra_info: ["extra_info", "extraInfo"],
  kvkk_rejected: ["kvkk_rejected", "kvkkRejected"],
  email_subscribed: ["email_subscribed", "emailSubscribed"],
  projects: ["projects"],
};

function isRecord(value) {
  return Boolean(value) && typeof value === "object" && !Array.isArray(value);
}

function compactValue(value) {
  if (value === null || value === undefined) return null;

  if (typeof value === "string") {
    const trimmed = value.trim();
    return trimmed || null;
  }

  if (Array.isArray(value)) {
    const compacted = value.map(compactValue).filter((item) => item !== null);
    return compacted.length ? compacted : null;
  }

  return value;
}

function getFirstValue(data, aliases) {
  for (const alias of aliases) {
    if (!Object.prototype.hasOwnProperty.call(data, alias)) continue;
    const value = compactValue(data[alias]);
    if (value !== null) {
      return value;
    }
  }
  return null;
}

export function normalizeCustomerInfo(input) {
  const data = isRecord(input) ? input : {};
  const normalized = {};

  for (const [key, aliases] of Object.entries(CUSTOMER_INFO_FIELD_ALIASES)) {
    const value = getFirstValue(data, aliases);
    if (value !== null) {
      normalized[key] = value;
    }
  }

  if (!normalized.full_name) {
    const firstName = typeof normalized.first_name === "string" ? normalized.first_name : null;
    const lastName = typeof normalized.last_name === "string" ? normalized.last_name : null;
    const fullName = [firstName, lastName].filter(Boolean).join(" ").trim();
    if (fullName) {
      normalized.full_name = fullName;
    }
  }

  return normalized;
}

export function mergeCustomerInfo(...inputs) {
  return normalizeCustomerInfo(
    inputs.reduce((acc, input) => {
      if (!isRecord(input)) return acc;
      return { ...acc, ...input };
    }, {})
  );
}
